import { render, staticRenderFns } from "./PermissMana.vue?vue&type=template&id=3c363c39"
import script from "./PermissMana.vue?vue&type=script&lang=js"
export * from "./PermissMana.vue?vue&type=script&lang=js"
import style0 from "./PermissMana.vue?vue&type=style&index=0&id=3c363c39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports